'use strict';

const Action = require('./Action');

/**
 * Regla de tipo Envío de notificación
 */
class NotificationAction extends Action {
    /**
     * Constructor estático
     *
     * @param  {...object}          args Argumentos del constructor
     *
     * @return {NotificationAction}      Instancia creada
     */
    static instance(...args) {
        return new this(...args);
    }

    /**
     * @inheritDoc
     */
    constructor(rawAction) {
        super(rawAction);

        this.type = Action.Types.NOTIFICATION;
        this.function = 'sendNotification';

        this.channels = rawAction.channels || [];
        this.subject = rawAction.subject || '';
        this.body = rawAction.body || '';
    }

    /**
     * Obtiene los canales destino de la notificación
     *
     * @return {string[]} Lista de canales
     */
    getChannels() {
        return this.channels;
    }

    /**
     * Obtiene el texto con el título de la notificación
     *
     * @return {string} El título definido
     */
    getSubject() {
        return this.subject;
    }

    /**
     * Obtiene el texto con el cuerpo del mensaje de la notificación
     *
     * @return {string} El cuerpo definido
     */
    getBody() {
        return this.body;
    }

    /**
     * Exportación de la acción en un objeto para la ejecución de las reglas
     *
     * @returns {ExportedAction} Objeto de exportación de la acción
     */
    export() {
        const rawAction = super.export();

        rawAction.channels = this.channels;
        rawAction.subject = this.subject;
        rawAction.body = this.body;

        return rawAction;
    }
}

module.exports = NotificationAction;
